import { call, put, takeEvery } from "redux-saga/effects";
import {
  CREATE_BENEFIT,
  DELETE_BENEFIT,
  DELETE_BENEFITS,
  FETCH_BENEFITS,
  GET_BENEFIT,
  GET_BENEFIT_VALUES,
  UPDATE_BENEFIT,
} from "./actionTypes";
import {
  createBenefitSuccess,
  createBenefitFailure,
  fetchBenefitsSuccess,
  fetchBenefitsFailure,
  updateBenefitFailure,
  updateBenefitSuccess,
  getBenefitSuccess,
  getBenefitFailure,
  deleteBenefitSuccess,
  deleteBenefitFailure,
  deleteBenefitsSuccess,
  deleteBenefitsFailure,
  getBenefitValueSuccess,
  getBenefitValueFailure,
} from "./action";

import {
  createBenefits,
  deleteBenefitsService,
  deleteMultipleBenefitsService,
  fetchBenefitsService,
  getBenefitService,
  getBenefitValuesService,
  updateBenefitService,
} from "../../helpers/backend_helper";
import { toast } from "react-toastify";

function* workCreateBenefit(action) {
  const { benefit, navigate } = action.payload;
  try {
    const userResponse = yield call(createBenefits, benefit);
    yield put(createBenefitSuccess(userResponse.data));
    navigate("/settings/benefits");
    toast.success(userResponse?.message);
  } catch (error) {
    yield put(createBenefitFailure(error));
    toast.error(error.message);
  }
}

// Update Benefits
function* workPutAccount(action) {
  const { benefit, navigate } = action.payload;
  try {
    const response = yield call(updateBenefitService, benefit.id, benefit);
    yield put(updateBenefitSuccess(response.data));
    navigate("/settings/benefits");
    toast.success(response?.message);
  } catch (error) {
    yield put(updateBenefitFailure(error));
    toast.error(error.message);
  }
}

// Fetch Benefits
function* workFetchBenefits(action) {
  try {
    const response = yield call(fetchBenefitsService, action.payload);
    yield put(fetchBenefitsSuccess(response.data));
  } catch (error) {
    yield put(fetchBenefitsFailure(error));
  }
}

function* workFetchBenefit(action) {
  try {
    const response = yield call(getBenefitService, action.payload);
    yield put(getBenefitSuccess(response.data));
  } catch (error) {
    yield put(getBenefitFailure(error));
  }
}

function* workDeleteBenefit(action) {
  try {
    const response = yield call(deleteBenefitsService, action.payload);
    yield put(deleteBenefitSuccess(action.payload));
    toast.success(response?.message);
  } catch (error) {
    yield put(deleteBenefitFailure(error));
    toast.error(error.message);
  }
}

function* workDeleteBenefits(action) {
  try {
    const response = yield call(deleteMultipleBenefitsService, action.payload);
    yield put(deleteBenefitsSuccess(action.payload));
    toast.success(response?.message);
  } catch (error) {
    yield put(deleteBenefitsFailure(error));
    toast.error(error.message);
  }
}

function* workFetchBenefitValues(action) {
  try {
    const { country, type } = action.payload;
    const response = yield call(getBenefitValuesService, country, type);
    yield put(getBenefitValueSuccess(response.data));
  } catch (error) {
    yield put(getBenefitValueFailure(error));
  }
}

export default function* watchFetchUserSaga() {
  yield takeEvery(CREATE_BENEFIT, workCreateBenefit);
  yield takeEvery(UPDATE_BENEFIT, workPutAccount);
  yield takeEvery(DELETE_BENEFIT, workDeleteBenefit);
  yield takeEvery(DELETE_BENEFITS, workDeleteBenefits);
  yield takeEvery(FETCH_BENEFITS, workFetchBenefits);
  yield takeEvery(GET_BENEFIT, workFetchBenefit);
  yield takeEvery(GET_BENEFIT_VALUES, workFetchBenefitValues);
}
